import '@mindscreen/videos/JavaScript/html.js';
import { init as initYouTube, initPlayer as initYouTubePlayer } from '@mindscreen/videos/JavaScript/lib/youtube';
import { SCRIPT_NAME, OPTIN_STATUS, getServiceStatus } from '@mindscreen/consent/FrontendSrc/public';
import { forAll } from '@ofm/util';

let youtubeOptInGranted = false;

document.addEventListener('DOMContentLoaded', () => {
    if (getServiceStatus('youtube') === OPTIN_STATUS.GRANTED) {
        initYouTube(false);
    } else {
        initYouTube();
    }
    window[SCRIPT_NAME].on('youtube', status => {
        if (status === OPTIN_STATUS.GRANTED) {
            if (!youtubeOptInGranted) {
                youtubeOptInGranted = true;
                initYouTube();
                forAll('.js-mscr-yt__wrapper:not(.mscr-yt__wrapper--loaded)', e => initYouTubePlayer(e, false));
            }
        }
    });
});
